import gsap from "gsap"

export const discardTrucoCard = ({
    card,
    totalSeats,
    seatIndex,
    cardX,
    cardY,
    addOnIndex = 0,
    animationCompleted = () => { },
    centerCardX,
    centerCardY,
    scaleX = 1,
    scaleY = 1,
}) => {
    card.dataset.seat = seatIndex
    card.dataset.totalseats = totalSeats

    const tl = gsap.timeline()
    tl.eventCallback("onComplete", animationCompleted)
    tl.fromTo(card, {
        x: cardX,
        y: cardY,
        scaleX: 1,
        scaleY: 1,
    }, {
        x: centerCardX,
        y: centerCardY,
        scaleX,
        scaleY,
        duration: 0.4,
        zIndex: 999 + addOnIndex,
        rotate: `0deg`,
        ease: "power4.out",
    })

    /**
     * snapToEnd()
     * Instantly places the card at its center position without animation.
     * Called from TableCanvas when the tab becomes visible again while a
     * discard animation was in-flight — the card appears already played,
     * no delayed fly-in on tab focus.
     */

    tl.snapToEnd = () => {
        tl.kill()
        gsap.set(card, {
            x: centerCardX,
            y: centerCardY,
            scaleX,
            scaleY,
            rotate: "0deg",
            zIndex: 999 + addOnIndex,
        })
        animationCompleted()
    }

    return tl
}